/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import { useGLTF } from '@react-three/drei'
import type { ObjectMap } from '@react-three/fiber'
import { type JSX } from 'react'
import type { Mesh, MeshStandardMaterial } from 'three'
import type { GLTF } from 'three-stdlib'

type GLTFResult = GLTF &
  ObjectMap & {
    nodes: {
      Node: Mesh
    }
    materials: {
      lambert2SG: MeshStandardMaterial
    }
  }

export function Ruler(props: JSX.IntrinsicElements['group']) {
  const { nodes, materials } = useGLTF('/models/ruler.glb') as GLTFResult
  return (
    <group {...props} dispose={null}>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Node.geometry}
        material={materials.lambert2SG}
        material-color="limegreen"
      />
    </group>
  )
}

useGLTF.preload('/models/ruler.glb')
